import { useTranslation } from 'react-i18next';
import {
  selectInstallableItems,
  selectThesisItems,
} from '@/utils/doctor-substitute';
import { FormSection } from '../../form-section';
import { BooleanSelectField } from '../boolean-select-field';
import { PriorityField } from '../priority-field';
import { ProfileTextField } from '../profile-text-field';
import { type DoctorProfileFormMode, isFieldVisible } from '../types';
import type { DoctorProfileUseForm } from '../use-doctor-profile-form';

/**
 * "Ordre et statut" section: Ordre number, RPPS, thesis, installable and the
 * staff-only priority.
 *
 * @param props.form - the unified profile form
 * @param props.mode - the form mode driving field visibility
 * @param props.showPriority - whether the viewer may rank the substitute
 * @returns the section
 */
export const OrderStatusSection = ({
  form,
  mode,
  showPriority,
}: {
  form: DoctorProfileUseForm;
  mode: DoctorProfileFormMode;
  showPriority: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t('edit-user-profile-form.section.order-status')}>
      <ProfileTextField
        form={form}
        name="orderRegistrationNumber"
        labelKey="edit-user-profile-form.order-registration-number.label"
      />
      {isFieldVisible(mode, 'rpps') && (
        <ProfileTextField
          form={form}
          name="rppsNumber"
          labelKey="edit-user-profile-form.rpps-number.label"
        />
      )}
      {isFieldVisible(mode, 'thesis') && (
        <BooleanSelectField
          form={form}
          fieldName="thesis"
          label="edit-user-profile-form.thesis.label"
          items={selectThesisItems}
        />
      )}
      {isFieldVisible(mode, 'installable') && (
        <BooleanSelectField
          form={form}
          fieldName="installable"
          label="edit-user-profile-form.installable.label"
          items={selectInstallableItems}
        />
      )}
      {showPriority && <PriorityField form={form} />}
    </FormSection>
  );
};
